import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import SupportTicketLink from '../../../../common/components/SupportTicketLink';
import SourceFileLink from './SourceFileLink';

const ExcelChartNoContentMessage = ({
  apiErrorCode,
  errorCode: errorCodeInput,
  item = {},
  isPwcUser,
  t,
}) => {
  const { tab, section } = item;
  const errorCode = errorCodeInput?.toString();

  if (isPwcUser) {
    if (errorCode) {
      if (errorCode.includes('108')) {
        return (
          <>
            <div className="content-section">
              <div>
                {t('chartSorryMessage')} <SourceFileLink item={item} />{' '}
                {t('chartRemoved')}
              </div>
            </div>

            <div className="content-section">
              {t('stillNotWorkingMsg')} <SupportTicketLink /> {t('forMoreHelp')}
            </div>
          </>
        );
      }

      if (
        errorCode.includes('106') ||
        [apiErrorCode, errorCode].some((x) => ['E1005-904'].includes(x))
      ) {
        return (
          <>
            <div className="content-section">
              {' '}
              <div>
                {t('sorryWeCantLoad')}
                {t('tabInFile', { tab })} <SourceFileLink item={item} />{' '}
                {t('tabMayHaveDeleted')}
              </div>
            </div>

            <div className="content-section">
              {t('stillNotWorkingMsg')} <SupportTicketLink /> {t('forMoreHelp')}
            </div>
          </>
        );
      }

      if (
        [apiErrorCode, errorCode].some((x) =>
          ['E1005-104', 'E1005-101'].includes(x)
        )
      ) {
        return (
          <>
            <div className="content-section">
              {' '}
              <div>
                {t('sorryWeCantLoad')}
                {t('fileMayHaveDeleted')}
              </div>
            </div>

            <div className="content-section">
              {t('stillNotWorkingMsg')} <SupportTicketLink /> {t('forMoreHelp')}
            </div>
          </>
        );
      }
    }
    // no error code clause
    return (
      <>
        <div className="content-section">
          <div>{t('objectMayHaveMoved')}</div>

          <div>
            {t('checkTheChart', { section, tab })}{' '}
            <SourceFileLink item={item} />. {t('useTheExcelAddIn')}
          </div>
        </div>

        <div className="content-section">
          <Trans
            i18nKey={
              errorCode
                ? 'ifIssueContinueCreateTicketForthisIssueWithError'
                : 'ifIssueContinueCreateTicketForthisIssue'
            }
            components={[<SupportTicketLink key="0" />]}
            values={{ errorCode }}
          />
        </div>
      </>
    );
  }

  // no user clause and fallback if any of above fails
  return (
    <>
      <div className="content-section">
        <div>{t('objectMayHaveMoved')}</div>
      </div>

      <div className="content-section">
        <Trans
          i18nKey={
            errorCode
              ? 'pleaseCreateTicketForthisIssueWithError'
              : 'pleaseCreateTicketForthisIssue'
          }
          components={[<SupportTicketLink key="0" />]}
          values={{ errorCode }}
        />
      </div>
    </>
  );
};

export default withTranslation()(ExcelChartNoContentMessage);
